<template>
    <div id="app">
        <VueExtendLayout />
    </div>
</template>

<script>
import VueExtendLayout from './layouts/default-page.vue';

export default {
    name: 'app',
    components: {
        VueExtendLayout,
    },
};
</script>
<style>
html.is-loading-cursor,
html.is-loading-cursor body,
html.is-loading-cursor .v-application {
    cursor: progress !important;
}
</style>
